import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import set from 'lodash/set';
import get from 'lodash/get';

const CHANGE_REQUEST_API = 'escrow-v2.requestApi/CHANGE_REQUEST_API';
const changeRequestApi = createAction(CHANGE_REQUEST_API);

const initialState = {
	api: {
		url: '',
		headers: null,
	},
	body: null,
};

export const actions = {
	changeRequestApi,
};

export default handleActions(
	{
		[CHANGE_REQUEST_API]: (state, action) =>
			produce(state, (draft) => {
				const values = action.payload;

				Object.keys(values).forEach((key) => {
					set(draft, key, get(values, key));
				});
			}),
	},
	initialState,
);
